const history = () => import(/* webpackChunkName: "herb" */ './history');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/guide/guide/history',
      name: 'guide_guide_history',
      component: history
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/guide/index/router.js